<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="foodTypes"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Typy jídla</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="650"
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-btn
                @click="editedItem = defaultItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                Přidat typ jídla
              </v-btn>
            </template>
            <FoodTypeForm
              :item="editedItem"
              v-if="dialog"
              @data-saved="getFoodTypes"
            >
            </FoodTypeForm>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editFoodType(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getFoodTypes">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import FoodTypeForm from '../../forms/admin/FoodTypeForm'
export default {
  name: 'FoodTypes',
  components: { FoodTypeForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        name: null,
        active: false
      },
      headers: [
        { text: 'Název', value: 'name' },
        { text: 'Aktivní', value: 'activeStr' },
        { text: 'Akce', value: 'actions' }
      ],
      foodTypes: []
    }
  },
  methods: {
    getFoodTypes () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/food-types')
        .then(response => {
          this.foodTypes = response.data.map(foodType => {
            foodType.activeStr = foodType.active ? 'Aktivní' : 'Deaktivováno'
            return foodType
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editFoodType (foodType) {
      this.editedItem = Object.assign({}, foodType)
      this.dialog = true
    },
    toggleActive (foodType) {
      foodType.active = !foodType.active
      this.$http.patch(`/admin/food-types/${foodType.id}`, this.keysToSnakeCase(foodType))
        .then(response => {
          this.getFoodTypes()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.getFoodTypes()
  }
}
</script>

<style scoped>

</style>
